export const cardInputStatuses = {
  EMPTY: '',
  INVALID: 'INVALID',
  SUCCESS: 'SUCCESS',
};

export type CardInputStatusType =
  typeof cardInputStatuses[keyof typeof cardInputStatuses];
